import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // 13 minutes and 18 seconds in seconds
  const initialTime = 13 * 60 + 18;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const displayTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full bg-red-600 text-white py-0.5 px-2 shadow-md text-center font-bold text-xs tracking-wide" data-id="element-1">
      {timeLeft > 0 ? <p data-id="element-2">⏳ OFERTA TERMINA EN: 03:29 | 🔥 CUPOS LIMITADOS</p> : <p data-id="element-3">⏳ OFERTA EXPIRADA | 🔥 CUPOS LIMITADOS</p>}
    </div>;
}